import { render } from "./DefaultPreview.vue?vue&type=template&id=63a79d0b&scoped=true"
import script from "./DefaultPreview.vue?vue&type=script&lang=js"
export * from "./DefaultPreview.vue?vue&type=script&lang=js"

import "./DefaultPreview.vue?vue&type=style&index=0&id=63a79d0b&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a79d0b"]])

export default __exports__